export type Size = {
  width: number;
  height: number;
};

export type AspectFormatProps = {
  title: string;
  icon: Partial<Size> & { url?: string };
  format?: string;
  formatLabel?: string;
};

const aspectDropdown = [
  {
    title: 'All video formats',
    icon: {
      url: 'images/video-templates/all-formats.svg'
    }
  },
  {
    title: 'Horizontal',
    format: '16:9',
    aspectLabel: 'horizontal',
    icon: {
      width: 50,
      height: 28
    }
  },
  {
    title: 'Square',
    format: '1:1',
    aspectLabel: 'square',
    icon: {
      width: 36,
      height: 36
    }
  },
  {
    title: 'Story & Reels',
    format: '9:16',
    aspectLabel: 'story-IGTV',
    icon: {
      width: 28,
      height: 50
    }
  },
  {
    title: 'Vertical',
    format: '4:5',
    aspectLabel: 'vertical',
    icon: {
      width: 32,
      height: 40
    }
  },
  {
    title: 'Facebook Cover',
    format: '1684:624',
    formatLabel: '2.7:1',
    aspectLabel: 'facebook-cover',
    icon: {
      width: 50,
      height: 22
    }
  }
] as AspectFormatProps[];

export default aspectDropdown;
